import React from 'react'
import MergeBaseMappingForm from './MergeBaseMappingForm';
import MergeBaseCredentialsForm from './MergeBaseCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function MergeBaseConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={MergeBaseMappingForm}
            CredentialsForm={MergeBaseCredentialsForm}
            componentName="Application Name"
            componentKey="instanceName"
        />
    )
}